import { useQuery } from "@tanstack/react-query";

import getQueryKeys from "common/datahooks/getQueryKeys";
import { useCampaignContext } from "common/helpers/CampaignContext";
import { post } from "common/helpers/HTTP";
import { useSelectedWorkspaceContext } from "common/helpers/SelectedWorkspaceContext";

async function getTypeaheadRequest(
  workspaceId: string,
  campaignId: string,
  type: string,
  query: string,
): Promise<{ text: string; id: string }[]> {
  const { options } = await post(
    `workspaces/${workspaceId}/campaigns/${campaignId}/sales-navigator/typeahead?count=100`,
    {
      type,
      query: query || undefined,
    },
  );
  return options;
}
export default function useNavigatorTypeahead({
  type,
  query,
}: {
  type: string;
  query?: string;
}) {
  const { id: campaignId } = useCampaignContext();
  const { id: workspaceId } = useSelectedWorkspaceContext();

  const { campaignsKeys } = getQueryKeys(workspaceId);

  const { data: typeaheadOptions, isLoading: isLoadingTypeaheadOptions } =
    useQuery({
      queryKey: campaignsKeys.navigatorTypeahead(campaignId, type, query),
      queryFn: () => getTypeaheadRequest(workspaceId, campaignId, type, query),
    });
  return { typeaheadOptions, isLoadingTypeaheadOptions };
}
